import type { Swatch } from "./types.js";

export type ImagePoint = { x: number; y: number };

export function pointerEventToImagePoint(event: PointerEvent, canvas: HTMLCanvasElement): ImagePoint {
  const rect = canvas.getBoundingClientRect();
  return {
    x: (event.clientX - rect.left) * (canvas.width / rect.width),
    y: (event.clientY - rect.top) * (canvas.height / rect.height),
  };
}

export function roundedRectContainsPoint(
  point: ImagePoint,
  rect: Pick<Swatch, "x" | "y" | "width" | "height" | "radius">,
): boolean {
  const { x, y } = point;
  const right = rect.x + rect.width;
  const bottom = rect.y + rect.height;
  if (x < rect.x || x > right || y < rect.y || y > bottom) return false;

  const radius = Math.max(0, Math.min(rect.radius, rect.width / 2, rect.height / 2));
  if (radius === 0) return true;

  const innerLeft = rect.x + radius;
  const innerRight = right - radius;
  const innerTop = rect.y + radius;
  const innerBottom = bottom - radius;
  if ((x >= innerLeft && x <= innerRight) || (y >= innerTop && y <= innerBottom)) return true;

  const cornerX = x < innerLeft ? innerLeft : innerRight;
  const cornerY = y < innerTop ? innerTop : innerBottom;
  const dx = x - cornerX;
  const dy = y - cornerY;
  return dx * dx + dy * dy <= radius * radius;
}

export function getSwatchAtPoint(imageX: number, imageY: number, swatches: readonly Swatch[]): Swatch | null {
  const point = { x: imageX, y: imageY };
  return swatches.find((swatch) => roundedRectContainsPoint(point, swatch)) ?? null;
}
